import React, { Component } from 'react'
import { PageContainerLayout, PageHeaderLayout } from '../../../layouts'
import { AccountingSeatSettingsWizardForm } from '../../containers/accounting-seat-settings-wizard-form'
import { NavLink } from 'react-router-dom'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { AccountingSeatSettingShape } from '../../../../prop-types'
import * as PropTypes from 'prop-types'
import { accountingSeatSettingsOperations } from '../../../../state/ducks/accounting-seat-settings'
import { connect } from 'react-redux'
import { Session } from '../../../../state/utils/session'

class AccountingSeatSettingEditorPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      session: new Session()
    }

    this.renderHeaderPaths = this.renderHeaderPaths.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.props.getAccountingSeatSetting(this.props.match.params.accounting_seat_setting_id)
  }

  renderHeaderPaths () {
    return (
            <>
                <li>
                    <NavLink className="link-effect"
                             to={ROUTING_PATHS.CLIENT_DASHBOARD_ACCOUNTING_SEAT_SETTINGS_PATH.replace(':client_id', this.state.session.getClientSession())}
                    >
                        Accounting Seat Settings
                    </NavLink>
                </li>
                <li>Edit Setting</li>
            </>
    )
  }

  render () {
    return (
            <>
                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout
                        title={this.props.accountingSeatSetting.name}
                        subTitle={'Edit Setting'}
                        paths={this.renderHeaderPaths}
                    />
                    <AccountingSeatSettingsWizardForm
                        accountingSeatSetting={this.props.accountingSeatSetting}
                        isEditor={true}
                    />
                </PageContainerLayout>
            </>
    )
  }
}

// Set propTypes
AccountingSeatSettingEditorPage.propTypes = {
  accountingSeatSetting: AccountingSeatSettingShape,
  getAccountingSeatSettingErrorResponse: PropTypes.object
}

// Set defaultProps
AccountingSeatSettingEditorPage.defaultProps = {
  accountingSeatSetting: {},
  getAccountingSeatSettingErrorResponse: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  accountingSeatSetting: state.accountingSeatSettings.getAccountingSeatSettingReducer.data,
  isLoading: state.accountingSeatSettings.getAccountingSeatSettingReducer.loading,
  getAccountingSeatSettingErrorResponse: state.accountingSeatSettings.getAccountingSeatSettingReducer.error_data
})

// mapStateToProps
const mapDispatchToProps = {
  getAccountingSeatSetting: accountingSeatSettingsOperations.get
}

// Export Class
const _AccountingSeatSettingEditorPage = connect(mapStateToProps, mapDispatchToProps)(AccountingSeatSettingEditorPage)
export { _AccountingSeatSettingEditorPage as AccountingSeatSettingEditorPage }
